import React from 'react';
import { observer } from 'mobx-react';
import { LoadingOverlay, VSpacer } from '@mqd/volt-base';
import { withProgramTransactionHistoryStore } from '../../../../../../hoc/withProgramTransactionHistoryStore.js';
import { ProgramTransactionHistoryStoreContext } from '../../../../../../context/ProgramTransactionHistoryStoreContext.js';
import { useScrollToTopIf } from '../../../../hooks/useScrollToTopIf.js';
import { useFetchHistory } from './hooks/use-fetch-history.js';
import Filters from './components/Filters/index.js';
import Table from '../Table/index.js';

const ProgramSpecificTab = () => {
  const { loading } = useFetchHistory();

  useScrollToTopIf(loading);

  return (
    <LoadingOverlay active={loading}>
      <VSpacer factor={2} />

      <Filters />

      <VSpacer factor={2} />

      <Table historyContext={ProgramTransactionHistoryStoreContext} />

      <VSpacer factor={1} />
    </LoadingOverlay>
  );
};

export default withProgramTransactionHistoryStore(observer(ProgramSpecificTab));
